<template>
<div class="chapter">
<div class="inner_page">
<div id="introduction">
<a id="page_6">
<div class="image-wrap" style="margin-top:1em; margin-bottom:1em;">
<div class="image">
<img alt="image" src="images/fm-3.jpg" style="max-width:100%"/>
<p class="paranoindent1" id="ch1-fig1"><b><em>American troops embarking into an LCA from a liner during the North Africa landings</em></b>.</p>
</div>
</div>
</a><a id="page_7">
<p class="paranoindent1" style="page-break-before:always !important;"> </p>
<p class="paranoindent1"> </p>
<p class="paranoindent1"> </p>
<p class="paranoindent1"> </p>
</a><p class="chap-title" id="intro" style="font-size:2.5em"><a id="page_7"></a><a href="#/text/05_toc#intro"><b>I<span class="small">NTRODUCTION</span></b></a></p>
<p class="paranoindent1"> </p>
<p class="paranoindent1"> </p>
<p class="paranoindent1"><span class="dropcap">T</span>HE Assault Landing Craft, or ALC, later known as the Landing Craft Assault (LCA), was the only serviceable British landing craft in the early stages of the Second World War. It had its first experience of combat, rather bizarrely, while landing the French Foreign Legion in Norway in 1940, and showed great promise during the evacuations from Dunkirk and Crete. It took part in many commando raids and landed the first British and Commonwealth troops in North Africa, Sicily and Italy. It was a tried and tested design by the time of the Normandy invasion, when it became the unsung hero. Boats commanded by leading hands or able seamen picked their way through beach obstacles to land the first waves of infantry, while more imaginative types of vessel such as the swimming tank, the Landing Craft (Rocket) and the Landing Craft Tank (Armoured) proved far less successful. It was still in service for the Suez operations in 1956.</p>
<p class="paraindent1">The assault landing craft was the humblest vessel in the wartime Royal Navy during the Second World War. It was commanded by a rating rather than an officer, it did not appear in the <em>Navy List</em>, it had no armament of its own and it had a number rather than a name. It had no accommodation for cooking or sleeping so it was not expected to be used independently. It might be regarded as equivalent to a ship’s boat, except that it was usually organised in flotillas and it was a true fighting vessel, not a support craft. It was certainly not pretty, in an age when the world had not yet become familiar with box-like vessels. Even in its role in amphibious operations, it tended to be dwarfed both literally and figuratively by larger vessels that could put tanks ashore with a certain amount of dramatic effect.</p>
<p class="paraindent1">Nearly 2000 were built and these were a vital link in allied wartime operations. If each landed its full complement of thirty-five men only once, that would make a total of nearly 70,000. But if the average craft carried out four or five landings in action conditions, then they would have landed around 300,000, perhaps even more, and it is quite possible that half a million soldiers had the experience of the short but uncomfortable and dangerous voyage onto a beach held by the enemy.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_introduction.vue?f53a94b2